"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HYPHEN = exports.SINGLE_SPACE = exports.TIMEZONE_ASIA = exports.SECONDS_PER_MINUTE = exports.EMPTY_STRING = exports.MILLISECONDS_PER_SECOND = void 0;
exports.MILLISECONDS_PER_SECOND = 1000;
exports.EMPTY_STRING = "";
exports.SECONDS_PER_MINUTE = 60;
exports.TIMEZONE_ASIA = 'Asia/Calcutta';
exports.SINGLE_SPACE = " ";
exports.HYPHEN = "-";
//# sourceMappingURL=immutable.js.map